import { getField, updateField } from 'vuex-map-fields'

const application = {
  namespaced: true,
  state: {
    showDrawer: null,
    isPrintMode: null
  },
  getters: {
    getField
  },
  mutations: {
    updateField,
    toggleDrawer: (state) => {
      state.showDrawer = !state.showDrawer
    },
    setPrintMode: (state) => {
      state.showDrawer = false
      state.isPrintMode = true
    },
    clearPrintMode: (state) => {
      state.showDrawer = true
      state.isPrintMode = false
    }
  },
  actions: {
    toggleDrawer: ({ commit }) => commit('toggleDrawer'),
    setPrintMode: ({ commit }) => commit('setPrintMode'),
    clearPrintMode: ({ commit }) => commit('clearPrintMode')
  }
}

export default application
